'use client'

import { Lib } from '@/types'
import { USE } from '@config'
import Script from 'next/script'
import { useEffect, useRef } from 'react'
import { query } from '.'

interface Props {
  data: Lib.ResultOf<typeof query>['setting']
}

const CONSENT_COOKIE_NAME = 'cookiesAccepted'

const Client = ({ data }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null)

  // Safety net: the consent widget's own "close" handler tries to remove
  // its mount point directly via the DOM API, but that element is also
  // rendered by React, which can silently leave it in place (or restore
  // it) on its next render since it never sees the external mutation.
  // Once the widget has recorded a decision (its own cookie is set),
  // force the mount point hidden ourselves, independent of whether its
  // own removal actually stuck.
  useEffect(() => {
    const hasConsentCookie = () =>
      document.cookie
        .split('; ')
        .some((c) => c.startsWith(`${CONSENT_COOKIE_NAME}=`))

    const hideIfConsented = () => {
      if (hasConsentCookie() && containerRef.current) {
        containerRef.current.style.setProperty('display', 'none', 'important')
        return true
      }
      return false
    }

    if (hideIfConsented()) return

    const interval = setInterval(() => {
      if (hideIfConsented()) clearInterval(interval)
    }, 500)

    return () => clearInterval(interval)
  }, [])

  if (USE.privacy === false) return null
  return (
    <>
      <div id="infotext" data-lenis-prevent></div>
      <div
        ref={containerRef}
        id="kekschecker"
        data-cid={data?.cid}
        data-key={data?.gtm}
        className="hidden"
        style={{ display: 'none' }}
      ></div>
      <Script
        src="https://legal.spotagency.ch/datenschutz/v2/kekschecker.js"
        async
      />
    </>
  )
}

export default Client
